import React from "react";

import styled from "styled-components/macro";

import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";

export default function CreatedBy() {
  const { createdBy } = useGetCurrentSignupList();

  if (!createdBy?.userID) {
    return <Wrapper>(coming soon)</Wrapper>;
  }

  const localeOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return (
    <Wrapper>
      Created by{" "}
      <span
        className={`can_mini_profile can_mini_profile_${createdBy.userID}`}
        data-userid={createdBy.userID}
      >
        {createdBy.name}
      </span>{" "}
      on{" "}
      {new Date(createdBy.date * 1000).toLocaleDateString(
        "en-us",
        localeOptions
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  margin-top: 12px;
  color: #9da5a6;
`;
